import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, HelpCircle, ArrowRight } from "lucide-react";
import { FAQS } from "../mock";
import { useSeo } from "../hooks/useSeo";

const Faq = () => {
  useSeo({
    title: "FAQ",
    description: "Answers to common questions about British Supplements: ingredients, the uptake blend, UK manufacturing, delivery and Subscribe & Save.",
    jsonLd: { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: FAQS.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) },
  });
  const [open, setOpen] = useState(0);

  return (
    <div>
      <div className="relative overflow-hidden bg-[#1B4332]">
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d281d] to-[#1B4332]/70" />
        <div className="relative mx-auto max-w-4xl px-4 py-16 text-center sm:px-6">
          <HelpCircle className="mx-auto mb-3 text-[#95D5B2]" size={34} />
          <h1 className="font-display text-4xl font-bold uppercase text-white sm:text-5xl">Frequently Asked Questions</h1>
          <p className="mx-auto mt-3 max-w-xl text-[#cfe0d6]">Everything you need to know about our clean, nasty-free supplements.</p>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="overflow-hidden rounded-2xl border border-[#e6f0ea] bg-white">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-display text-[15px] font-semibold uppercase tracking-wide text-[#1B2a21]">{f.q}</span>
                  <ChevronDown size={20} className={`shrink-0 text-[#2D6A4F] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 leading-relaxed text-[#4a5c51]">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 rounded-3xl bg-[#f0f7f2] p-8 text-center">
          <h2 className="font-display text-2xl font-bold uppercase text-[#1B4332]">Still have a question?</h2>
          <p className="mt-2 text-[#4a5c51]">We're real people and happy to help.</p>
          <Link to="/shop" className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#2D6A4F] px-7 py-3 font-display text-sm font-bold uppercase tracking-wider text-white transition hover:bg-[#1B4332]">
            Shop Products <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Faq;
